import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@rsos/components/capstone/Queue/Alert';
import { Box, Text } from '@rsos/components/capstone/base';
import { getTheme } from '@rsos/theme/themes';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';

/**
 * Component for rendering call data in a popup. Currently only used for Esri
 * @param {Object} popupData
 */
const AlertPopup = ({
  data,
  userProfile,
  createdAt,
  isAllView,
  themeName = 'light',
}) => {
  const theme = getTheme(themeName);
  const isTrainAlertOrTest =
    `${data?.emergency_type?.name}`.includes('TRAIN') ||
    `${data?.emergency_type?.name}`.startsWith('TEST');
  const popupTitle = isTrainAlertOrTest
    ? data?.emergency_type?.display_name
    : `${data?.site_type?.display_name} ${data?.emergency_type?.display_name}`;
  return (
    <>
      {isAllView ? (
        <Alert
          alert={data}
          isMapMarker={true}
          userProfile={userProfile}
          theme={theme}
        />
      ) : (
        <Box padding="4px 8px">
          <Text paddingBottom="4px">{popupTitle}</Text>
          <Text paddingBottom="4px">
            {convertUnixTimestamp(createdAt, true)}
          </Text>
          <Text size="small" color="secondaryText">
            Source: {data.service_provider_name}
          </Text>
        </Box>
      )}
    </>
  );
};

AlertPopup.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isCentralStation: PropTypes.bool,
  userID: PropTypes.string,
  alertCreatedAt: PropTypes.number,
  isAllView: PropTypes.bool,
  themeName: PropTypes.oneOf(['light', 'dark']),
};

export default AlertPopup;
